import { CapitalizePipe } from '../../shared/pipes/capitalize.pipe';

export function capitalize ( capitalizePipe : CapitalizePipe ) {
  return ( input : string ) : string => capitalizePipe.transform(input);
};
